/**
 * Strips all html tags from the given string
 */
export const stripTags = (original: string): string =>
  original.replace(/(<([^>]+)>)/gi, '');
